// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export interface IDriverControlResult {
	accepted: boolean;

	message: string | undefined;

	commandId: string | undefined;

	sentToDevice: boolean;

	completed: boolean;

	succeeded: boolean | undefined;

	triggerId: string | undefined;

	$type?: string | undefined;
}
export class DriverControlResult {
	constructor(data?: IDriverControlResult) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	accepted: boolean = false;

	message: string | undefined;

	commandId: string | undefined;

	sentToDevice: boolean = false;

	completed: boolean = false;

	succeeded: boolean | undefined;

	triggerId: string | undefined;

	static $type: string = "CoreApi.Models.DriverControlResult, ";
	$type?: string | undefined = DriverControlResult.$type;
}

